import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useContactsParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = searchParams.get('page');
  const limit = searchParams.get('limit');
  const orderBy = searchParams.get('orderBy') || undefined;
  const sort = searchParams.get('sort') || undefined;
  const search = searchParams.get('search') || undefined;
  const filters = searchParams.get('filters') || undefined;
  const status = searchParams.get('status') || undefined;
  const fieldsString = searchParams.get('fields');
  const fields = useMemo(
    () => fieldsString?.split(',').filter(Boolean) ?? [],
    [fieldsString]
  );
  const hasFields = fields.length > 0;

  const updateParam = useCallback(
    (key, value) => {
      setSearchParams((prevParams) => {
        const newParams = new URLSearchParams(prevParams);
        if (value === null || value === '' || value === undefined) {
          newParams.delete(key);
        } else {
          newParams.set(key, value);
        }

        if (key === 'fields') {
          const currentOrderBy = newParams.get('orderBy');
          if (currentOrderBy) {
            const newFields = value.split(',').filter(Boolean);
            if (!newFields.includes(currentOrderBy)) {
              newParams.delete('orderBy');
              newParams.delete('sort');
            }
          }
        }

        return newParams;
      });
    },
    [setSearchParams]
  );

  return {
    params: {
      ...(page ? { page: Number(page) } : { page: 1 }),
      ...(limit ? { limit: Number(limit) } : { limit: 10 }),
      ...(orderBy ? { orderBy } : hasFields ? { orderBy: fields[0] } : {}),
      ...(sort ? { sort } : {}),
      ...(search ? { search } : {}),
      ...(filters ? { filters } : {}),
      ...(hasFields ? { fields: fields.join(',') } : {}),
      ...(status ? { status } : {}),
    },
    fieldArray: fields,
    hasFields,
    updateParam,
  };
}
